import api from '../index'

/**
 * @description 学生列表
 * @returns {Promise} 请求结果
 */
export function reqStudentList(data?: any) {
  return api.post('/common/students/index', data)
}
/**
 * @description 班级列表
 * @returns {Promise} 请求结果
 */
export function reqClassesList(data?: any) {
  return api.post('/common/classes/index', data)
}
/**
 * @description 记录访问量
 * @returns {Promise} 请求结果
 */
export function reqPageRecord(data?: any) {
  return api.post('/common/pageLogs/record', data)
}
